"use client";

import React from "react";
import { Mail, MapPin, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="145559" className="flex flex-col gap-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-5 w-24 bg-muted/10 animate-pulse" />)}
      </div>;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors font-sans uppercase tracking-widest text-[12px]">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function StructuralFooter() {
  const currentYear = new Date().getFullYear();
  const operations = ["Remote-First Operations", "Nationwide Land Acquisition", "Fully Digital Closings"];
  const phones = ["(515)-421-5911"];
  return <section id="footer" className="dark bg-background text-foreground font-sans border-t border-border/10 relative overflow-hidden">
      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0%); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee {
          animation: marquee 25s linear infinite;
        }
      `}</style>

      <div className="container mx-auto px-4 md:px-6 pt-16 pb-12">
        <div className="mb-16 border-b border-border/10 pb-8 flex flex-col md:flex-row md:items-end justify-between gap-6">
          <Link to="/HomePage" className="inline-block">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1610811/img/brentwood_enterprises_logo.png" alt="Brentwood Enterprises LLC" className="h-10 md:h-14 w-auto object-contain brightness-0 invert" />
          </Link>
          <p className="text-xs uppercase tracking-[0.3em] text-muted-foreground font-mono">
            Remote-First | Nationwide Land Buyers
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          <div>
            <h3 className="text-sm font-extrabold uppercase tracking-tighter mb-6 text-foreground font-sans">
              Quick Links
            </h3>
            <MenuProvider menu_id="17">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          <div>
            <h3 className="text-sm font-extrabold uppercase tracking-tighter mb-6 text-foreground font-sans">
              Operations
            </h3>
            <ul className="flex flex-col gap-4">
              {operations.map((op, i) => <li key={i} data-index={i} className="flex items-start gap-3 text-muted-foreground">
                  <MapPin className="w-4 h-4 text-primary shrink-0 mt-0.5" />
                  <span className="text-[12px] uppercase tracking-widest font-mono">{op}</span>
                </li>)}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-extrabold uppercase tracking-tighter mb-6 text-foreground font-sans">
              Get In Touch
            </h3>
            <ul className="flex flex-col gap-4">
              <li className="flex items-start gap-3 text-muted-foreground">
                <Phone className="w-4 h-4 text-primary shrink-0 mt-0.5" />
                <div className="flex flex-col gap-1">
                  <Link data-index="0" to="tel:5154215911" className="text-[12px] uppercase tracking-widest font-mono hover:text-primary transition-colors">
                    (515)-421-5911
                  </Link>
                </div>
              </li>
              <li className="flex items-start gap-3 text-muted-foreground mt-2">
                <Mail className="w-4 h-4 text-primary shrink-0 mt-0.5" />
                <Link to="mailto:offers@brentwoodland.com" className="text-[12px] uppercase tracking-widest font-mono transition-colors break-all !w-[260px] hover:text-primary">info@brentwoodenterprisesllc.com</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="bg-background py-8 text-center border-t border-border/10">
        <p className="text-[10px] text-muted-foreground uppercase tracking-[0.2em] font-mono px-4">
          &copy; {currentYear} Brentwood Enterprises. All Rights Reserved. | No Physical Office — Fully Digital Operations
        </p>
      </div>
    </section>;
}